import { render, staticRenderFns } from "./AdicionarPeso.vue?vue&type=template&id=b5a69a22&scoped=true"
import script from "./AdicionarPeso.vue?vue&type=script&lang=js"
export * from "./AdicionarPeso.vue?vue&type=script&lang=js"
import style0 from "./AdicionarPeso.vue?vue&type=style&index=0&id=b5a69a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a69a22",
  null
  
)

export default component.exports